class MultipackQuantitySelector extends HTMLElement {
  #boundSellingPlanChange;

  connectedCallback() {
    this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
    this.hiddenInput = this.querySelector('input[type="hidden"][name="quantity"]');
    this.selectedTitleEl = this.querySelector('.product__selected-variant-title');

    this.priceBlock = document.querySelector('product-price');
    this.priceContainer = this.priceBlock?.querySelector('[ref="priceContainer"]') || this.priceBlock;

    this.stickyComparePriceEl = document.querySelector('[ref="buttonComparePrice"]');
    this.stickySalePriceEl = document.querySelector('[ref="buttonPrice"]');

    this.addEventListener('change', this.#onRadioChange.bind(this));

    this.#boundSellingPlanChange = this.#onSellingPlanChange.bind(this);
    document.addEventListener('change', this.#boundSellingPlanChange);

    const checked = this.radios.find((radio) => radio.checked);
    this.#applySelection(checked);
    this.#syncSubscriptionLock();
  }

  disconnectedCallback() {
    document.removeEventListener('change', this.#boundSellingPlanChange);
  }

  #onRadioChange(event) {
    if (event.target.type !== 'radio') return;
    this.#applySelection(event.target);
  }

  #onSellingPlanChange(event) {
    if (event.target.name !== 'selling_plan') return;
    this.#syncSubscriptionLock();
  }

  #parsePrice(text) {
    if (!text) return 0;
    return parseFloat(text.replace('€', '').replace(/\./g, '').replace(',', '.').trim()) || 0;
  }

  #syncSubscriptionLock() {
    const sellingPlanRadios = Array.from(document.querySelectorAll('input[name="selling_plan"]'));
    const isSubscription = sellingPlanRadios.some((radio) => radio.checked && radio.value !== '');

    this.classList.toggle('multipack-quantity-selector--locked', isSubscription);

    this.radios.forEach((radio, index) => {
      const isFirstOption = index === 0;
      radio.disabled = isSubscription && !isFirstOption;
    });

    if (isSubscription) {
      const firstRadio = this.radios[0];
      if (firstRadio && !firstRadio.checked) {
        firstRadio.checked = true;
      }
      this.#applySelection(firstRadio);
    }
  }

  #getSalePriceEl() {
    return this.priceContainer?.querySelector('.price') || null;
  }

  #getCompareGroupEl() {
    const compareEl = this.priceContainer?.querySelector('.compare-at-price');
    return compareEl ? compareEl.closest('[role="group"]') : null;
  }

  #ensureCompareGroup() {
    let group = this.#getCompareGroupEl();
    if (group) return group;

    const salePriceEl = this.#getSalePriceEl();
    if (!salePriceEl || !this.priceContainer) return null;

    const saleGroup = salePriceEl.closest('[role="group"]') || salePriceEl.parentElement;

    group = document.createElement('span');
    group.setAttribute('role', 'group');
    group.innerHTML = '<span class="visually-hidden">Normaler Preis&nbsp;</span><span class="compare-at-price"></span>';

    if (saleGroup && saleGroup.parentElement === this.priceContainer) {
      this.priceContainer.insertBefore(group, saleGroup);
    } else {
      this.priceContainer.insertBefore(group, this.priceContainer.firstChild);
    }

    return group;
  }

  #ensureTooltip() {
    if (!this.priceContainer) return null;
    let wrapper = this.priceContainer.querySelector('.custom-tooltip-wrapper');
    if (wrapper) return wrapper;

    wrapper = document.createElement('span');
    wrapper.className = 'custom-tooltip-wrapper';
    wrapper.innerHTML = '<h6 class="tooltiptext"></h6>';
    this.priceContainer.appendChild(wrapper);
    return wrapper;
  }

  #applySelection(radio) {
    if (!radio) return;

    if (this.hiddenInput) {
      this.hiddenInput.value = radio.dataset.packQuantity;
    }

    const comparePriceValue = this.#parsePrice(radio.dataset.variantPrice);
    const salePriceValue = this.#parsePrice(radio.dataset.variantSalePrice);
    const hasDiscount = comparePriceValue > salePriceValue;

    const salePriceEl = this.#getSalePriceEl();
    if (salePriceEl) {
      salePriceEl.textContent = ' ' + (radio.dataset.variantSalePrice || '');
    }

    if (hasDiscount) {
      const group = this.#ensureCompareGroup();
      const compareEl = group?.querySelector('.compare-at-price');
      if (compareEl) compareEl.textContent = radio.dataset.variantPrice || '';
      if (group) group.style.display = '';

      const tooltipWrapper = this.#ensureTooltip();
      const tooltipText = tooltipWrapper?.querySelector('.tooltiptext');
      if (tooltipText) {
        const realPercent = Math.round((1 - salePriceValue / comparePriceValue) * 100);
        tooltipText.textContent = `Spare ${realPercent}%`;
      }
      if (tooltipWrapper) tooltipWrapper.style.display = '';
    } else {
      const group = this.#getCompareGroupEl();
      if (group) group.style.display = 'none';

      const tooltipWrapper = this.priceContainer?.querySelector('.custom-tooltip-wrapper');
      if (tooltipWrapper) tooltipWrapper.style.display = 'none';
    }

    if (this.stickySalePriceEl) {
      this.stickySalePriceEl.textContent = radio.dataset.variantSalePrice || '';
    }

    if (this.stickyComparePriceEl) {
      if (hasDiscount) {
        this.stickyComparePriceEl.textContent = radio.dataset.variantPrice || '';
        this.stickyComparePriceEl.style.display = '';
      } else {
        this.stickyComparePriceEl.style.display = 'none';
      }
    }

    if (this.selectedTitleEl && radio.dataset.optionName) {
      this.selectedTitleEl.textContent = radio.dataset.optionName;
    }
  }
}

if (!customElements.get('multipack-quantity-selector')) {
  customElements.define('multipack-quantity-selector', MultipackQuantitySelector);
}